import React, { Component } from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import { get } from 'lodash'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  DashboardGrid as Grid,
  ElevatedButton,
  MaterialControlBar
} from 'components/layout'
import { SendAJCompletion } from 'containers/forms/dashboard'
import { CenteredContent, Note, CircleBadge } from 'components/misc'
import { ACTIVITY_STATES } from 'constants/enums'
import { ObservationOverview } from 'components/sections/dashboard'

const centeredStyle = {
  marginTop: '150px',
  paddingBottom: 150,
  flexDirection: 'column'
}

@connect(({ api }) => ({
  isFileUploading: api.blob.loading
}))
class AJReport extends Component {
  static propTypes = {
    colorClass: PropTypes.string,
    journeyType: PropTypes.string,
    onClickReport: PropTypes.func,
    isFileUploading: PropTypes.bool,
    onAssessorRequest: PropTypes.func,
    onLeaderRequest: PropTypes.func,
    onCompleteAJParticipantEvent: PropTypes.func,
    event: PropTypes.object
  }

  state = {
    isEdit: false
  }

  handleStartEditObservation = () => this.setState({ isEdit: true })

  handleCancelEdit = () => this.setState({ isEdit: false })

  handleCompletionAJ = (...params) =>
    this.props
      .onCompleteAJParticipantEvent(...params)
      .then(this.handleCancelEdit)
      .then(this.props.onAssessorRequest)

  renderSendSection = ({ colorClass }) => (
    <div>
      <MaterialControlBar
        edit={{
          onClick: this.handleStartEditObservation,
          intlKey: 'button.edit_observation',
          label: 'Edit Observation'
        }}
      />
      <Note intlKey="label.you_can_send_aj_to_leader">
        You can now send your Residential Project to your Award Leader for
        approval.
      </Note>
      <ElevatedButton
        colorClass={colorClass}
        onClick={this.props.onAssessorRequest}
        intlKey="button.send_for_approval"
      >
        Send for approval
      </ElevatedButton>
    </div>
  )

  render() {
    const {
      event,
      colorClass,
      journeyType,
      onClickReport,
      isFileUploading
    } = this.props
    const { isEdit } = this.state
    const state = get(event, 'state.value')
    const isAssessmentPositive = get(event, 'isAssessmentPositive')
    const id = get(event, 'id')
    const observations = get(event, 'observations')
    const fileUrls = get(event, 'fileUrls', [])
    const sendSectionParams = {
      journeyType,
      colorClass,
      onClickReport
    }

    return (
      <Grid.RightInner white={ACTIVITY_STATES.in_progress.id === state}>
        {ACTIVITY_STATES.in_progress.id === state && (
          <div className="row">
            {!isEdit &&
              observations && (
                <div className="col-xs-12">
                  <ObservationOverview
                    header={this.renderSendSection(sendSectionParams)}
                    colorClass={colorClass}
                    observations={observations}
                    fileUrls={fileUrls}
                  />
                </div>
              )}

            {(isEdit || !observations) && (
              <div className="col-xs-6">
                <SendAJCompletion
                  id={id}
                  /* loading={get(completionStatus, 'loading')} */
                  colorClass={colorClass}
                  onSubmit={this.handleCompletionAJ}
                  initialValues={isEdit ? { observations, fileUrls } : null}
                  isEditing={isEdit}
                  submitDisabled={isFileUploading}
                  onCancel={this.handleCancelEdit}
                />
              </div>
            )}
          </div>
        )}
        {ACTIVITY_STATES.assessment.id === state && (
          <div>
            {!isAssessmentPositive && (
              <CenteredContent flex textAlign style={centeredStyle}>
                <CircleBadge colorClass={colorClass} large medal padded>
                  <i className="ico ico--timer" />
                </CircleBadge>
                <Note margin="25px 0 0 0">
                  <FormattedHTMLMessage
                    id="label.your_report_has_been_sent_assessor"
                    defaultMessage="Your Report has been sent to the Assessor. <br /> Now we wait for his/her Approval."
                  />
                </Note>
              </CenteredContent>
            )}
            {isAssessmentPositive && (
              <ElevatedButton
                colorClass={colorClass}
                uppercase
                rounded
                submit
                padded
                intlKey="button.send_for_approval"
                inline
                onClick={this.props.onLeaderRequest}
              >
                Send for approval
              </ElevatedButton>
            )}
          </div>
        )}

        {ACTIVITY_STATES.award_leader_singoff.id === state && (
          <CenteredContent flex textAlign style={centeredStyle}>
            <CircleBadge colorClass={colorClass} large medal padded>
              <i className="ico ico--timer" />
            </CircleBadge>
            <Note margin="25px 0 0 0">
              <FormattedHTMLMessage
                id="label.your_report_has_been_sent_leader"
                defaultMessage="Your Report has been sent to your Award Leader."
              />
            </Note>
          </CenteredContent>
        )}

        {[
          ACTIVITY_STATES.complete.id,
          ACTIVITY_STATES.ceremony.id,
          ACTIVITY_STATES.office_signoff.id
        ].includes(state) && (
          <CenteredContent flex textAlign style={centeredStyle}>
            <CircleBadge colorClass={colorClass} large medal>
              <i className="ico ico--icon-victory" />
            </CircleBadge>
            <Note margin="25px 0 0 0">
              <FormattedHTMLMessage
                id="label.your_journey_is_complete"
                defaultMessage="Your {journeyType} Journey is complete."
                values={{
                  journeyType: get(
                    event,
                    'ajEvent.ajEventCategory.translationText'
                  )
                }}
              />
            </Note>
          </CenteredContent>
        )}
      </Grid.RightInner>
    )
  }
}

export default AJReport
